const bibSelector = 'input[name="filter.p.m.global.bib_no"]';
let bibValue = new URL(window.location.href).searchParams.get('filter.p.m.global.bib_no') || '';

function syncBibInputs(root = document) {
  const inputs = root.matches?.(bibSelector) ? [root] : root.querySelectorAll?.(bibSelector) || [];
  for (const input of inputs) {
    if (input !== document.activeElement) input.value = bibValue;
  }
}

document.addEventListener('facet:update', (event) => {
  if (!event.detail?.url) return;
  bibValue = new URL(event.detail.url, window.location.origin).searchParams.get('filter.p.m.global.bib_no') || '';
  syncBibInputs();
});

document.addEventListener('shopify:section:load', (event) => syncBibInputs(event.target));
window.addEventListener('pageshow', () => {
  bibValue = new URL(window.location.href).searchParams.get('filter.p.m.global.bib_no') || '';
  syncBibInputs();
});
const observer = new MutationObserver((records) => {
  for (const record of records) {
    for (const node of record.addedNodes) {
      if (node.nodeType === Node.ELEMENT_NODE) syncBibInputs(node);
    }
  }
});
observer.observe(document.body, { childList: true, subtree: true });
syncBibInputs();
